import cn from "classnames";

import styles from "./PackFreeLabel.module.scss";
import labelStyles from "../packLabel.module.scss";

interface Props {
  isFree: boolean;
  className?: string;
}

export const PackFreeLabel = (props: Props) => {
  const { isFree, className } = props;

  if (isFree) {
    return <div className={cn(styles.free, labelStyles.label, className)}>Free</div>;
  }
  return null;
};
